import { render } from "./no-access.html?vue&type=template&id=53bf1288&scoped=true&ts=true&external"
import script from "./no-access.ts?vue&type=script&lang=ts&external"
export * from "./no-access.ts?vue&type=script&lang=ts&external"

import "./no-access.scss?vue&type=style&index=0&id=53bf1288&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53bf1288"]])

export default __exports__